import { sessionClient } from '@/modules/session';

const state = {
  profile: null,
  sessionChecked: false,
  sessionUnavailable: false,
  tempToken: undefined,
  mailConfirmation: {
    email: undefined,
    new: false,
  },
};

const getters = {
  tempToken: ({ tempToken }) => tempToken,
  mailConfirmation: ({ mailConfirmation }) => mailConfirmation,
  isLoggedIn: ({ profile }) => !!profile,
  tokenPayLoad: ({ profile }) => profile,
  sessionChecked: ({ sessionChecked }) => sessionChecked,
  sessionUnavailable: ({ sessionUnavailable }) => sessionUnavailable,
  userID: (state, getters) => {
    const payload = getters.tokenPayLoad;
    if (payload) {
      return Number.parseInt(payload.upn);
    }
  },
  userGroup: (state, getters) => {
    const payload = getters.tokenPayLoad;
    if (payload) {
      return payload.groups[0];
    }
  },
  playerID: (state, getters) => {
    const payload = getters.tokenPayLoad;
    if (payload) {
      return payload.playerId;
    }
  },
  playerName: (state, getters) => {
    const payload = getters.tokenPayLoad;
    if (payload) {
      return payload.playerName;
    }
  },
  playerUUID: (state, getters) => {
    const payload = getters.tokenPayLoad;
    if (payload) {
      return payload.playerUUID;
    }
  },
  isTeamMember: (state, getters) => {
    const payload = getters.tokenPayLoad;
    if (payload) {
      return payload.isTeamMember;
    }
  },
};

let sessionRevision = 0;
const actions = {
  async refreshSession ({ commit }, { fresh = false } = {}) {
    const revision = sessionRevision;
    try {
      const profile = await (fresh ? sessionClient.fresh() : sessionClient.current());
      if (revision === sessionRevision) commit('setSession', profile);
      return profile;
    } catch (error) {
      if (revision === sessionRevision) commit('setSessionUnavailable');
      throw error;
    }
  },
  async logout ({ commit }) {
    sessionRevision++;
    await sessionClient.logout();
    commit('setSession', null);
  },
};

const mutations = {
  setSession (state, profile) {
    state.profile = profile;
    state.sessionChecked = true;
    state.sessionUnavailable = false;
  },
  setSessionUnavailable (state) {
    state.sessionUnavailable = true;
  },
  setTempToken (state, token) {
    state.tempToken = token;
  },
  setMailConfirmation (state, mailConfirmation) {
    state.mailConfirmation = mailConfirmation;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
